import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";

const AdminCreateGroupOnboarding = () => {
  const navigate = useNavigate();
  const apiBase = useMemo(() => config.API_BASE_URL || "http://localhost:5003", []);
  const token = useMemo(() => localStorage.getItem("token"), []);
  const [groupName, setGroupName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!token) return;
    fetch(`${apiBase}${config.ADMIN.ONBOARDING_STATUS}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => res.json())
      .then((payload) => {
        if (!payload?.profileCompleted) {
          navigate("/admin/profile-setup", { replace: true });
          return;
        }
        if (payload?.groupCreated) {
          navigate("/admin/home", { replace: true });
        }
      })
      .catch(() => {});
  }, [apiBase, navigate, token]);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${apiBase}/admin/groups`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ name: groupName })
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        if (payload?.redirectTo) {
          navigate(payload.redirectTo, { replace: true });
          return;
        }
        throw new Error(payload?.message || "Failed to create group");
      }
      localStorage.setItem("groupName", payload?.name || groupName.trim());
      navigate(payload?.redirectTo || "/admin/home", { replace: true });
    } catch (err) {
      setError(err.message || "Failed to create group");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <form style={card} onSubmit={submit}>
        <h1 style={title}>Create Your Family Circle Group</h1>
        <p style={subtitle}>This is required once during onboarding.</p>
        <label style={label}>
          Family Circle Group Name
          <input
            style={input}
            value={groupName}
            required
            onChange={(event) => setGroupName(event.target.value)}
          />
        </label>
        {error ? <p style={errorText}>{error}</p> : null}
        <button style={button} type="submit" disabled={loading}>
          {loading ? "Creating..." : "Create Group and Continue"}
        </button>
      </form>
    </div>
  );
};

export default AdminCreateGroupOnboarding;

const page = {
  minHeight: "calc(100vh - 112px)",
  background: "#f3f7fb",
  display: "grid",
  placeContent: "center",
  padding: "24px"
};

const card = {
  width: "min(560px, 92vw)",
  background: "#fff",
  border: "1px solid #d9e5ef",
  borderRadius: "16px",
  boxShadow: "0 12px 32px rgba(15,23,42,0.08)",
  padding: "24px",
  display: "grid",
  gap: "12px"
};

const title = {
  margin: 0,
  color: "#0E5580"
};

const subtitle = {
  margin: 0,
  color: "#64748b"
};

const label = {
  display: "grid",
  gap: "6px",
  color: "#334155",
  fontWeight: "600"
};

const input = {
  border: "1px solid #cbd5e1",
  borderRadius: "10px",
  padding: "14px 16px",
  fontSize: "18px"
};

const button = {
  border: "none",
  borderRadius: "10px",
  minHeight: "52px",
  padding: "14px 16px",
  background: "#0E5580",
  color: "#fff",
  fontSize: "18px",
  fontWeight: "700",
  cursor: "pointer"
};

const errorText = {
  margin: 0,
  color: "#b91c1c"
};
